import React, {useEffect, useState} from 'react';
import {Badge, Card, Divider} from 'antd-mobile';
import {useNavigate} from 'react-router-dom';
import {DeliveringPath} from "../../../../enums/DeliveryNavigatePathEnum";
import {ExceptionDictionaryType} from "../../graphql/queries/getExceptionDictionaryForDelivery";
import {t} from "../../../../i18n";
import {useTranslation} from "react-i18next";
import { getExceptionTypeText } from '../../../../utils/i18nUtils';
import { formatStopNumber } from '../../../../utils/stopNumberUtils';

export interface DeliveringOrder {
    id: number;
    trackingNumber:  string;
    deliveryAttempts: number;
    stopNumber:  number;
    subStopNumber?: string | null;
    fullName: string;
    address: string;
    routeNumber: string;
    expectedDeliveryTime: string;
    deliveryType:string;
    deliveredAt: string;
    phone:string;
    exceptionReason?:ExceptionDictionaryType;
    isPickUp?:boolean;
    isAbnormal?:boolean;
    isDelivered?:boolean;
    isDelivery?:boolean;
    isReturnToWhsScanned?:boolean;
    isFinished?:boolean;
    isTransferIn?: boolean;
}

interface OrderCardProps {
    order: DeliveringOrder;
    activeTab?: string;
}

const OrderCard: React.FC<OrderCardProps> = ({order, activeTab}) => {
    const navigate = useNavigate();
    const { i18n } = useTranslation();
    const [exceptionReasonMsg,setExceptionReasonMsg] = useState<string>('');
    const handleCardClick = () => {
        // 保存主容器的滚动位置
        const mainContainer = document.getElementById('delivering-main-container') as HTMLElement;
        if (mainContainer) {
            sessionStorage.setItem('deliveringPageScrollTop', mainContainer.scrollTop.toString());
        }
        
        navigate(DeliveringPath.DELIVERY_DELIVERING_ORDER.replace(':trackingNumber', order.trackingNumber),{
            state:{
                deliveryTaskOrderId: order.id,
                trackingNumber: order.trackingNumber,
                activeTab: activeTab
            }
        });
    };
    useEffect(() => {
        const exceptionReason = order.exceptionReason;
        if(exceptionReason){
            const reasonMsg = getExceptionTypeText(exceptionReason);
            setExceptionReasonMsg(reasonMsg);
        }else {
            setExceptionReasonMsg("")
        }
    }, [order,activeTab]);

    return (
        <Card className="my-2 rounded-lg" onClick={handleCardClick}>
            <div className="flex justify-between items-center">
                <div className="text-base font-medium break-all">{order.trackingNumber}</div>
                <div className="flex items-center gap-2">
                    {order.deliveryAttempts >= 1 && (
                        <Badge content={order.deliveryAttempts || 0} className="bg-orange-600" />
                    )}
                </div>
            </div>
            <Divider/>
            <div className="flex gap-6">
                <div className="flex flex-col min-w-14 max-w-32 items-center justify-center gap-0.5">
                    {(() => {
                        const stopNumber = formatStopNumber(order.stopNumber, order.subStopNumber);
                        return (
                            <div className={`${stopNumber.length > 4 ? 'text-2xl' : 'text-3xl'} font-bold whitespace-nowrap`}>
                                {stopNumber}
                            </div>
                        );
                    })()}
                    <div className="text-xs">{t('pages.stop')}</div>
                </div>

                <div className="flex flex-col gap-1">
                    <h3 className="text-base font-semibold">{order.fullName}</h3>
                    <p>{order.address}</p>
                    <div className="flex items-center">
                        <p className="flex-1">{t('pages.delivery.orderDetail.route')}: {order.routeNumber}</p>
                        {order.isTransferIn && (
                            <span
                                className="px-2 py-0.5 text-xs font-medium text-white whitespace-nowrap mr-2"
                                style={{ backgroundColor: '#0096E8', fontSize: 12, lineHeight: '20px' }}
                            >
                                {t('pages.delivery.delivering.transferTag')}
                            </span>
                        )}
                    </div>
                    {activeTab === 'undelivered' && <p className="text-blue-400">{exceptionReasonMsg || ''}</p>}
                </div>
            </div>

        </Card>
    );
};

export default OrderCard;